<template>
  <div
    class="w-full h-full flex flex-col overflow-auto overflow-x-hidden menuPannelContent"
  >
    <DataGetter
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
      contentId="subscription"
    />
    <DataGetter
      @dataAvailable="
        data => {
          platformAccessSubscription = data?.metaData
        }
      "
      @dataIsEmpty="platformAccessSubscription = null"
      contentId="platformAccessSubscription"
    />
    <DataGetter
      @dataAvailable="
        data => {
          nbDeliveryLocations = (data?.metaData?.locations || []).length
        }
      "
      contentId="deliveryLocations"
    />
    <DataGetter
      @dataAvailable="
        data => {
          nbProducts = (data || []).length
        }
      "
      contentId="products"
    />

    <div class="py-4"></div>
    <div class="flex px-4 items-center gap-4">
      <!-- <div class="w-14 h-14 overflow-hidden rounded-2xl">
        <img src="/images/logo-bg.png" alt="" />
      </div> -->
      <div class="h-9 min-w-max relative" v-if="!pannelCollapsed">
        <div class="min-w-max font-bold flex gap-1 text-4xl">
          <span class="text-primary-400"> Eki </span>
          <span class="text-secondary"> Discount </span>
        </div>
        <div
          class="absolute bottom-0 right-0 bg-blue-500 text-white px-2 text-sm rounded-lg translate-y-1/3 translate-x-1/2"
          v-if="platformAccessSubscription?.isActive"
        >
          {{ platformAccessSubscription?.planName }}
        </div>
      </div>
      <div class="h-9 w-9 min-w-max relative" v-else>
        <img src="/images/logo-bg.png" class="h-full w-full relative" alt="" />
        <div
          class="absolute bottom-0 right-0 bg-blue-500 whitespace-nowrap text-white px-2 text-sm rounded-lg translate-y-1/3 translate-x-1/2"
          v-if="platformAccessSubscription?.isActive"
        >
          {{ platformAccessSubscription?.planName }}
        </div>
      </div>
    </div>
    <div
      class="duration-300"
      :class="{ 'py-2': !pannelCollapsed, 'py-4': pannelCollapsed }"
    ></div>
    <div
      class="p-4 py-0"
      v-for="(nav, i) in navs"
      :key="i"
      :permission="nav.permission || 'none'"
      :class="[nav.cssClasses]"
    >
      <VDropdown
        v-if="!nav.content"
        :distance="6"
        theme="tooltip-light"
        placement="right"
        :triggers="pannelCollapsed ? ['hover'] : []"
      >
        <component
          :is="nav.path ? 'router-link' : 'div'"
          :to="nav.path"
          class="font-semibold flex p-4 items-center gap-4 ripple rounded-2xl duration-300 hover:bg-primary-100"
          @click="selectNav(nav)"
          :class="[
            {
              ' text-primary bg-primary-100': isActive(nav),
              'w-14': pannelCollapsed,
            },
          ]"
        >
          <div
            class="w-6 min-w-6 h-6 duration-300"
            :class="[{ 'saturate-0 brightness-[1.2]': !isActive(nav) }]"
          >
            <img :src="nav.icon" alt="" class="w-full h-full" />
          </div>
          <div class="duration-300" :class="{ 'opacity-0': pannelCollapsed }">
            {{ nav.name }}
          </div>
          <div class="ml-auto"><div v-html="nav.rightContent"></div></div>
        </component>
        <template #popper>
          {{ nav.name }}
        </template>
      </VDropdown>

      <div v-else-if="nav.content == 'BigPub'" class="py-6">
        <div class="w-full relative text-white" v-if="!pannelCollapsed">
          <div
            class="w-full h-full absolute bg-blue-600 rounded-content-md"
          ></div>
          <div class="relative p-4">
            <div class="py-4 md:py-0"></div>

            <div class="text-3xl md:text-2xl font-bold text-center">
              EkiDiscount Pro
            </div>
            <div
              class="duration-300"
              :class="{ 'py-0': pannelCollapsed, 'py-2': !pannelCollapsed }"
            ></div>
            <div
              class="text-primary-300 text-center px-4 md:px-0 text-lg md:text-sm"
            >
              Personalisez votre boutique et accédez plus d'options
            </div>
            <div class="py-2"></div>
            <div>
              <component
                :is="subscription.isActive ? 'router-link' : 'router-link'"
                to="/pro"
                @click="this.$emit('navClicked')"
                class="text-xl md:text-lg inline-block buttonComponent rounded-xl px-4 py-4 md:py-2 bg-primary-300 bg-opacity-50 ripple w-full relative"
              >
                <div class="relative">
                  <!-- {{ subscription.isActive ? 'Vous êtes pro' : 'Devenir Pro' }} -->
                  Vous êtes {{ platformAccessSubscription?.planName }}
                </div>
              </component>
            </div>
            <div class="py-4 md:py-0"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4"></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import DataGetter from '../utils/DataGetter.vue'
import ScrollComponent from '../utils/ScrollComponent.vue'

export default defineComponent({
  name: 'MenuPannelContent',
  components: { DataGetter, ScrollComponent },
  props: {
    pannelCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      eventsIds: [],
      subscription: {},
      platformAccessSubscription: null,
      nbDeliveryLocations: null,
      nbProducts: null,
    }
  },
  mounted() {},
  methods: {
    selectNav(nav) {
      // if (nav.path) this.$router.push(nav.path).catch(() => {});
      if (nav.event) this.$Events.dispatchEvent(nav.event)
      else if (nav.onClick) nav.onClick()

      this.$emit('navClicked')
    },
    isActive(nav) {
      return this.$route.path == nav?.path
    },
  },
  watch: {},
  computed: {
    lockForPlatformAccessPayment() {
      return (
        this.platformAccessSubscription &&
        !this.platformAccessSubscription.isActive
      )
    },
    navs() {
      if (this.lockForPlatformAccessPayment)
        return [
          {
            cssClasses: 'mt-auto',
            name: this.$t('menuPannel.logout'),
            icon: '/images/icons/logout_1.svg',
            event: 'logout_requested',
          },
        ]
      return [
        {
          name: 'Dashboard',
          icon: '/images/icons/dashboard-interface.svg',
          path: '/home',
          permission: 'dashboard',
        },
        {
          name: 'Produits',
          icon: '/images/icons/delivery-box.svg',
          path: '/products',
          rightContent:
            this.nbProducts !== null
              ? this.nbProducts
                ? `(${this.nbProducts})`
                : '<span class="text-red-500 font-bold text-2xl">!</span>'
              : '',
          permission: 'history',
        },
        {
          name: 'Deals',
          icon: '/images/icons/fire.svg',
          path: '/deals',
          permission: 'history',
        },
        {
          name: 'Promotions',
          icon: '/images/icons/megaphone.svg',
          path: '/promotion',
          permission: 'history',
        },
        {
          name: 'Commandes',
          icon: '/images/icons/purchase-order.svg',
          path: '/orders',
          permission: 'history',
        },
        {
          name: 'Paiements',
          icon: '/images/icons/transaction-history.svg',
          path: '/payments',
          permission: 'payments',
        },
        {
          name: 'Chargebacks',
          icon: '/images/icons/refund.svg',
          path: '/chargebacks',
          permission: 'chargebacks',
        },
        {
          name: 'Clients',
          icon: '/images/icons/users-avatar.svg',
          path: '/customers',
          permission: 'customers',
        },
        {
          name: 'Livreurs',
          icon: '/images/icons/motorcycle.svg',
          path: '/riders',
          permission: 'riders',
        },
        {
          name: 'Zone de livraison',
          icon: '/images/icons/map.svg',
          rightContent:
            this.nbDeliveryLocations !== null
              ? this.nbDeliveryLocations
                ? ''
                : '<span class="text-red-500 font-bold text-2xl">!</span>'
              : '',
          path: '/deliveryLocations',
          permission: 'deliveryLocations',
        },
        {
          name: 'Transferts',
          icon: '/images/icons/transfer.svg',
          path: '/transfer',
          permission: 'transfer',
        },
        {
          name: 'Reversements',
          icon: '/images/icons/bank-_1_.svg',
          path: '/withdrawal',
          permission: 'withdrawal',
        },
        {
          name: 'Préférences',
          icon: '/images/icons/settings.svg',
          path: '/preferences',
          permission: 'preferences',
        },
        {
          cssClasses: 'mt-auto',
          name: '',
          content: 'BigPub',
          icon: '/images/icons/delivery-box.svg',
          path: '/paymentlink',
          permission: 'payment-links',
        },
        {
          cssClasses: 'mt-auto',
          name: 'Aide & support',
          icon: '/images/icons/call-center.svg',
          path: '/chat',
          permission: 'payment-pages',
        },
        {
          name: this.$t('menuPannel.logout'),
          icon: '/images/icons/logout_1.svg',
          event: 'logout_requested',
        },
      ]
    },
  },
})
</script>
